/**
 * Custom TXT File Icon Component
 * Replaces lucide-react FileText with custom design
 */

interface TxtIconProps {
    className?: string
}

export function TxtIcon({ className = "w-12 h-12" }: TxtIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className={className}
        >
            {/* Documento base */}
            <path
                d="M112 32h224l96 96v304c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z"
                fill="currentColor"
                opacity="0.1"
            />

            {/* Dobra */}
            <path
                d="M336 32v96h96z"
                fill="#5E86F7"
            />

            {/* Linhas de texto */}
            <rect x="152" y="136" width="176" height="10" rx="5" fill="#5E86F7" />
            <rect x="152" y="158" width="176" height="10" rx="5" fill="#5E86F7" />
            <rect x="152" y="180" width="176" height="10" rx="5" fill="#5E86F7" />
            <rect x="152" y="202" width="176" height="10" rx="5" fill="#5E86F7" />

            {/* Faixa azul inferior */}
            <rect
                x="0"
                y="272"
                width="512"
                height="128"
                rx="32"
                fill="#5E86F7"
            />

            {/* Texto TXT */}
            <text
                x="256"
                y="344"
                textAnchor="middle"
                dominantBaseline="middle"
                fontFamily="Arial Black, Arial, Helvetica, sans-serif"
                fontSize="104"
                fontWeight="900"
                letterSpacing="4"
                fill="#FFFFFF"
            >
                TXT
            </text>

            {/* Linha inferior */}
            <rect x="176" y="432" width="160" height="10" rx="5" fill="#5E86F7" />
        </svg>
    )
}
